<script>
export default {
  data() {
    return {
      isClick: false,
      isClicked: false,
      isClickedOne: false,
      isClickedTwo: false,
      isClickedThree: false,
      isClickedFour: false,
      title: "Services",
      text: "Services",
    };
  },
  methods: {
    toggleClick() {
      this.isClick = !this.isClick;
    },
    toggleClicked() {
      this.isClicked = !this.isClicked;
    },
    toggleClickedOne() {
      this.isClickedOne = !this.isClickedOne;
    },
    toggleClickedTwo() {
      this.isClickedTwo = !this.isClickedTwo;
    },
    toggleClickedThree() {
      this.isClickedThree = !this.isClickedThree;
    },
    toggleClickedFour() {
      this.isClickedFour = !this.isClickedFour;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <services-breadcrumb :title="title" :text="text" />
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row">
          <services-sidebar></services-sidebar>
          <div class="col-xl-9 col-lg-8">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <h4>Found <span class="text-primary">11 Services</span></h4>
              <div class="d-flex align-items-center">
                <span class="text-dark me-2">Sort</span>
                <div class="dropdown me-2">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle bg-light-300"
                    data-bs-toggle="dropdown"
                  >
                    Price Low to High
                  </a>
                  <div class="dropdown-menu">
                    <a href="javascript:void(0);" class="dropdown-item active"
                      >Price Low to High</a
                    >
                    <a href="javascript:void(0);" class="dropdown-item"
                      >Price High to Low</a
                    >
                  </div>
                </div>
                <router-link
                  to="/service/services-grid"
                  class="tags d-flex justify-content-center align-items-center rounded me-2"
                  ><i class="ti ti-layout-grid"></i
                ></router-link>
                <router-link
                  to="/service/services-list"
                  class="tags d-flex justify-content-center align-items-center border bg-primary rounded"
                  ><i class="ti ti-list"></i
                ></router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <!-- Service List -->
                <div class="service-list">
                  <div class="service-cont">
                    <div class="service-cont-img">
                      <router-link to="/details/service-details">
                        <img
                          class="img-fluid serv-img"
                          alt="Service Image"
                          src="@/assets/img/services/service-04.jpg"
                        />
                      </router-link>
                      <div class="fav-item">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          :class="{ selected: isClick }"
                          @click="toggleClick"
                        >
                          <i class="feather-heart"></i>
                        </a>
                      </div>
                    </div>
                    <div class="service-cont-info">
                      <span class="badge bg-light fs-14 mb-2">Car Wash</span>
                      <h3 class="title">
                        <router-link to="/details/service-details"
                          >Car Repair Services</router-link
                        >
                      </h3>
                      <p><i class="feather-map-pin"></i>Maryland City, MD, USA</p>
                      <div class="service-pro-img">
                        <img src="@/assets/img/profiles/avatar-01.jpg" alt="user" />
                        <span><i class="fas fa-star filled me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <div class="service-action">
                    <h6>$25.00<span class="old-price">$35.00</span></h6>
                    <router-link to="/booking/booking" class="btn btn-light"
                      >Book Now</router-link
                    >
                  </div>
                </div>
                <!-- /Service List -->

                <!-- Service List -->
                <div class="service-list">
                  <div class="service-cont">
                    <div class="service-cont-img">
                      <router-link to="/details/service-details">
                        <img
                          class="img-fluid serv-img"
                          alt="Service Image"
                          src="@/assets/img/services/service-02.jpg"
                        />
                      </router-link>
                      <div class="fav-item">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          :class="{ selected: isClicked }"
                          @click="toggleClicked"
                        >
                          <i class="feather-heart"></i>
                        </a>
                      </div>
                    </div>
                    <div class="service-cont-info">
                      <span class="badge bg-light fs-14 mb-2">Construction</span>
                      <h3 class="title">
                        <router-link to="/details/service-details"
                          >Toughened Glass Fitting Services</router-link
                        >
                      </h3>
                      <p><i class="feather-map-pin"></i>New Jersey, USA</p>
                      <div class="service-pro-img">
                        <img src="@/assets/img/profiles/avatar-02.jpg" alt="User" />
                        <span><i class="fas fa-star filled me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <div class="service-action">
                    <h6>$30.00<span class="old-price">$35.00</span></h6>
                    <router-link to="/booking/booking" class="btn btn-light"
                      >Book Now</router-link
                    >
                  </div>
                </div>
                <!-- /Service List -->

                <!-- Service List -->
                <div class="service-list">
                  <div class="service-cont">
                    <div class="service-cont-img">
                      <router-link to="/details/service-details">
                        <img
                          class="img-fluid serv-img"
                          alt="Service Image"
                          src="@/assets/img/services/service-06.jpg"
                        />
                      </router-link>
                      <div class="fav-item">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          :class="{ selected: isClickedOne }"
                          @click="toggleClickedOne"
                        >
                          <i class="feather-heart"></i>
                        </a>
                      </div>
                    </div>
                    <div class="service-cont-info">
                      <span class="badge bg-light fs-14 mb-2">Computer</span>
                      <h3 class="title">
                        <router-link to="/details/service-details"
                          >Computer &amp; Server AMC Service</router-link
                        >
                      </h3>
                      <p><i class="feather-map-pin"></i>California, USA</p>
                      <div class="service-pro-img">
                        <img src="@/assets/img/profiles/avatar-05.jpg" alt="User" />
                        <span><i class="fas fa-star filled me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <div class="service-action">
                    <h6>$30.00<span class="old-price">$35.00</span></h6>
                    <router-link to="/booking/booking" class="btn btn-light"
                      >Book Now</router-link
                    >
                  </div>
                </div>
                <!-- /Service List -->

                <!-- Service List -->
                <div class="service-list">
                  <div class="service-cont">
                    <div class="service-cont-img">
                      <router-link to="/details/service-details">
                        <img
                          class="img-fluid serv-img"
                          alt="Service Image"
                          src="@/assets/img/services/service-07.jpg"
                        />
                      </router-link>
                      <div class="fav-item">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          :class="{ selected: isClickedTwo }"
                          @click="toggleClickedTwo"
                        >
                          <i class="feather-heart"></i>
                        </a>
                      </div>
                    </div>
                    <div class="service-cont-info">
                      <span class="badge bg-light fs-14 mb-2">Interior</span>
                      <h3 class="title">
                        <router-link to="/details/service-details"
                          >Interior Designing</router-link
                        >
                      </h3>
                      <p><i class="feather-map-pin"></i>Maryland, USA</p>
                      <div class="service-pro-img">
                        <img src="@/assets/img/profiles/avatar-06.jpg" alt="User" />
                        <span><i class="fas fa-star filled me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <div class="service-action">
                    <h6>$15.00<span class="old-price">$25.00</span></h6>
                    <router-link to="/booking/booking" class="btn btn-light"
                      >Book Now</router-link
                    >
                  </div>
                </div>
                <!-- /Service List -->

                <!-- Service List -->
                <div class="service-list">
                  <div class="service-cont">
                    <div class="service-cont-img">
                      <router-link to="/details/service-details">
                        <img
                          class="img-fluid serv-img"
                          alt="Service Image"
                          src="@/assets/img/services/service-09.jpg"
                        />
                      </router-link>
                      <div class="fav-item">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          :class="{ selected: isClickedThree }"
                          @click="toggleClickedThree"
                        >
                          <i class="feather-heart"></i>
                        </a>
                      </div>
                    </div>
                    <div class="service-cont-info">
                      <span class="badge bg-light fs-14 mb-2">Cleaning</span>
                      <h3 class="title">
                        <router-link to="/details/service-details"
                          >House Cleaning Services</router-link
                        >
                      </h3>
                      <p><i class="feather-map-pin"></i>Georgia</p>
                      <div class="service-pro-img">
                        <img src="@/assets/img/profiles/avatar-09.jpg" alt="User" />
                        <span><i class="fas fa-star filled me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <div class="service-action">
                    <h6>$55.00<span class="old-price">$60.00</span></h6>
                    <router-link to="/booking/booking" class="btn btn-light"
                      >Book Now</router-link
                    >
                  </div>
                </div>
                <!-- /Service List -->

                <!-- Service List -->
                <div class="service-list">
                  <div class="service-cont">
                    <div class="service-cont-img">
                      <router-link to="/details/service-details">
                        <img
                          class="img-fluid serv-img"
                          alt="Service Image"
                          src="@/assets/img/services/service-10.jpg"
                        />
                      </router-link>
                      <div class="fav-item">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          :class="{ selected: isClickedFour }"
                          @click="toggleClickedFour"
                        >
                          <i class="feather-heart"></i>
                        </a>
                      </div>
                    </div>
                    <div class="service-cont-info">
                      <span class="badge bg-light fs-14 mb-2">Construction</span>
                      <h3 class="title">
                        <router-link to="/details/service-details"
                          >Building Construction Services</router-link
                        >
                      </h3>
                      <p><i class="feather-map-pin"></i>Montana, USA</p>
                      <div class="service-pro-img">
                        <img src="@/assets/img/profiles/avatar-09.jpg" alt="User" />
                        <span><i class="fas fa-star filled me-1"></i>4.9</span>
                      </div>
                    </div>
                  </div>
                  <div class="service-action">
                    <h6>$45.00<span class="old-price">$50.00</span></h6>
                    <router-link to="/booking/booking" class="btn btn-light"
                      >Book Now</router-link
                    >
                  </div>
                </div>
                <!-- /Service List -->
              </div>
            </div>
            <nav aria-label="Page navigation">
              <ul class="paginations d-flex justify-content-center align-items-center">
                <li class="page-item me-3">
                  <a class="page-link"><i class="ti ti-arrow-left me-2"></i>Prev</a>
                </li>
                <li class="page-item me-2">
                  <a
                    class="page-link-1 active d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >1</a
                  >
                </li>
                <li class="page-item me-2">
                  <a
                    class="page-link-1 d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >2</a
                  >
                </li>
                <li class="page-item me-3">
                  <a
                    class="page-link-1 d-flex justify-content-center align-items-center"
                    href="javascript:void(0);"
                    >3</a
                  >
                </li>
                <li class="page-item">
                  <a class="page-link" href="javascript:void(0);"
                    >Next<i class="ti ti-arrow-right ms-2"></i
                  ></a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
</template>
